
import { defineComponent, SetupContext, ref, computed, onMounted, nextTick } from "vue";
import NativeClient from "@/client/native-client";
import PantryRadioItem from "./PantryRadioItem.vue";
import {
  PANTRY_STORAGE_TYPE,
  PANTRY_STORAGE_ID,
  DETAIL_ITEM_TITLE,
  PANTRY_NEW_STORAGE_TYPE
} from "@/types/pantry";

export default defineComponent({
  name: "PantryStroageValueDialog",
  components: {
    PantryRadioItem
  },
  props: {
    value: {
      type: Number,
      default: PANTRY_STORAGE_ID.ALL
    }
  },
  setup(props, context: SetupContext) {
    const selectId = ref(props.value);
    const selectChecked = (id: number) => {
      selectId.value = id;
    };
    const onClickSetting = () => {
      context.emit("click-setting", selectId.value);
    };
    const onClickClose = () => {
      context.emit("click-close");
    };
    return {
      selectId,
      selectChecked,
      onClickSetting,
      onClickClose,
      PANTRY_STORAGE_TYPE,
      PANTRY_STORAGE_ID,
      DETAIL_ITEM_TITLE,
      PANTRY_NEW_STORAGE_TYPE
    };
  }
});
